import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

import { supabase } from '../lib/supabase';

interface LoginPageProps {
  isMenuOpen?: boolean;
}

export default function LoginPage({
  isMenuOpen = false
}: LoginPageProps) {

  const navigate = useNavigate();

  const [isSignUp, setIsSignUp] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const BRAND = '#34de9aab';

  const handleSubmit = async () => {

    setLoading(true);
    setError('');
    setMessage('');

    try {

      // SIGN UP
      if (isSignUp) {

        const { data, error } =
  await supabase.auth.signUp({
    email,
    password
  });

if (error) throw error;

if (data.user) {

  const { error: profileError } =
    await supabase
      .from('profiles')
      .insert({
        id: data.user.id,
        email: data.user.email,
        plan: 'ENTRY',
        sessions_completed: 0
      });

  if (profileError) {
    throw profileError;
  }
}

        if (error) throw error;

        setMessage(
          'Account created! Please check your email verification.'
        );

      } else {

        // LOGIN
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password
        });

        if (error) throw error;

        navigate('/');
      }

    } catch (err: any) {

      setError(err.message);

    } finally {

      setLoading(false);

    }
  };

  return (
    <GridLayout
      isMenuOpen={isMenuOpen}

      left={<Menu />}

      main={
        <Card sx={{ p: 4 }}>

          <Typography
            variant="h4"
            sx={{
              color: BRAND,
              fontWeight: 'bold',
              mb: 3
            }}
          >
            {isSignUp ? 'Create Account' : 'Log In'}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              maxWidth: 420
            }}
          >

            {error && (
              <Alert severity="error">
                {error}
              </Alert>
            )}

            {message && (
              <Alert severity="success">
                {message}
              </Alert>
            )}

            <TextField
              label="Email"
              fullWidth
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
            />

            <TextField
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
            />

            <Button
              variant="contained"
              disabled={loading}
              onClick={handleSubmit}
              sx={{
                bgcolor: BRAND,
                py: 1.2,
                fontWeight: 'bold',

                '&:hover': {
                  bgcolor: '#2bb37c'
                }
              }}
            >

              {loading ? (
                <CircularProgress
                  size={22}
                  sx={{ color: 'white' }}
                />
              ) : (
                isSignUp ? 'Create Account' : 'Log In'
              )}

            </Button>

            {!isSignUp ? (

              <Button
                onClick={() =>
                  setIsSignUp(true)
                }
                sx={{
                  color: BRAND
                }}
              >
                Create account
              </Button>

            ) : (

              <Button
                onClick={() =>
                  setIsSignUp(false)
                }
                sx={{
                  color: BRAND
                }}
              >
                Already have an account?
              </Button>

            )}

          </Box>

        </Card>
      }

      right={<Box />}
    />
  );
}